import sliceCreator from '../../index.jsx';
import {GET_MEDIA_FILES} from '../../../constants/index.jsx';
const _getAllMediaFilesAction = sliceCreator('GET_MEDIA_FILES', GET_MEDIA_FILES, 'get');

const { asyncAction: getAllMediaFilesAction, reducer, clearData: clearGetAllMediaFilesAction } = _getAllMediaFilesAction;

export default reducer;

export {
    getAllMediaFilesAction,
    clearGetAllMediaFilesAction
}